import { render, staticRenderFns } from "./PalletsList.vue?vue&type=template&id=21cb126c&scoped=true&"
import script from "./PalletsList.vue?vue&type=script&lang=js&"
export * from "./PalletsList.vue?vue&type=script&lang=js&"
import style0 from "./PalletsList.vue?vue&type=style&index=0&id=21cb126c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cb126c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VTooltip})
